<template lang="pug">
#laudos
    p {{ $t('laudos.selecioneTipoDeInsumoParaCriacaoDeLaudo') }}
    slot
        .modal-container-inner-filtros
        .filtro-tipo-consulta
            .mb-3
                el-radio-group.radio-group-container(v-model='tipoBusca')
                    el-radio.radio-button(label='CAR', :aria-hidden='true') CAR
                    el-radio.radio-button(
                        :aria-hidden='true',
                        label='TERRITORIO',
                        :disabled='desabilitarTerritorio(usuarioLogado)'
                    ) {{ $t('laudos.territorio') }}
                    el-radio.radio-button(
                        label='ARQUIVO_VETORIAL',
                        :aria-hidden='true'
                    ) {{ $t('laudos.arquivoVetorialKml') }}
            #idCar.busca(v-if='tipoBusca === "CAR"')
                SelecionarCar(
                    :tipoLaudo='tipoLaudo',
                    :camadas='camadas',
                    :culturas='culturas',
                    :safras='safras',
                    :carregandoListas='carregandoListas',
                    @getLaudos='getLaudos',
                    @cancelar-modal='changeShowModalSelecionarTerritorio'
                )
            #idTerritorio.busca(v-if='tipoBusca === "TERRITORIO"')
                SelecionarTerritorio(
                    :tipoLaudo='tipoLaudo',
                    :camadas='camadas',
                    :culturas='culturas',
                    :safras='safras',
                    :carregandoListas='carregandoListas',
                    @getTerritoriosSelecionados='solicitarLaudos',
                    @cancelar-modal='changeShowModalSelecionarTerritorio',
                    ref='selecionarTerritorio'
                )
            #idVetor.busca(v-if='tipoBusca === "ARQUIVO_VETORIAL"')
                SelecionarArquivoVetorial(
                    :camadas='camadas',
                    :safras='safras',
                    :culturas='culturas',
                    :tipoLaudo='tipoLaudo',
                    :carregandoListas='carregandoListas',
                    @update:lista='requestLaudos',
                    @cancelar-modal='changeShowModalSelecionarTerritorio'
                )
</template>

<script>
import SelecionarTerritorio from '@/modules/laudos/components/avaliacaoSocioambiental/SelecionarTerritorio.vue';
import SelecionarCar from '@/modules/laudos/components/avaliacaoSocioambiental/SelecionarCar.vue';
import SelecionarArquivoVetorial from '@/modules/laudos/components/avaliacaoSocioambiental/SelecionarArquivoVetorial.vue';
import TipoLaudo from '@/modules/laudos/constants/TipoLaudo';
import LaudosService from '@/modules/laudos/services/LaudosService';
import UtilsService from '@/modules/laudos/services/UtilsService';
import { mapGetters } from 'vuex';

export default {
    name: 'Laudos',
    components: {
        SelecionarTerritorio,
        SelecionarCar,
        SelecionarArquivoVetorial
    },
    computed: {
        ...mapGetters(['usuarioLogado'])
    },
    data() {
        return {
            tipoLaudo: TipoLaudo.AVALIACAO_SOCIOAMBIENTAL,
            showModalVisualizacao: false,
            showModalSelecionarTerritorios: false,
            showModalConfirmarTerritorios: false,
            territoriosSelecionados: [],
            pageParams: {
                page: 1,
                size: 20,
                sort: 'dataCadastro,DESC'
            },
            filtros: {
                dataCadastroFim: '',
                dataCadastroInicio: '',
                dataFinalizacaoFim: '',
                dataFinalizacaoInicio: '',
                representantesCpfCnpj: [],
                situacaoId: '',
                statusId: '',
                territoriosIds: [],
                car: '',
                tipoLaudoId: TipoLaudo.AVALIACAO_SOCIOAMBIENTAL
            },
            totalLaudos: 0,
            laudos: [],
            safras: [],
            culturas: [],
            camadas: [],
            carregandoListas: false,
            idLaudo: null,
            rowInfo: null,
            showModalInsercaoResultados: false,
            usuariosBuffer: {},
            loading: false,
            isLaudoUnico: false,
            tipoBusca: 'CAR'
        };
    },
    mounted() {
        this.obterListas();
    },
    methods: {
        async getLaudos() {
            await this.requestLaudos();
        },

        async obterListas() {
            this.carregandoListas = true;
            await this.obterCamadas();
            await this.getSafras();
            await this.getCulturas();
            this.carregandoListas = false;
        },
        async getSafras() {
            try {
                const { data } = await UtilsService.getSafras();

                this.safras = data;
            } catch (error) {
                this.$notify.error({
                    message: 'Não foi possível buscar os dados de safras.'
                });
            }
        },
        async obterCamadas() {
            try {
                const { data } = await UtilsService.getCamadasVinculadas(
                    this.usuarioLogado.idGrupo
                );

                this.camadas = data;
            } catch (error) {
                this.$notify.error({
                    message: 'Não foi possível buscar os dados de camadas.'
                });
            }
        },
        async getCulturas() {
            try {
                const { data } = await LaudosService.getCulturas();

                this.culturas = data;
            } catch (error) {
                this.$notify.error({
                    message: 'Não foi possível buscar os dados de culturas.'
                });
            }
        },
        changeShowModalConfirmarTerritorios() {
            this.showModalConfirmarTerritorios =
                !this.showModalConfirmarTerritorios;
        },

        solicitarLaudos(territoriosSelecionados) {
            this.changeShowModalSelecionarTerritorio();
            this.changeShowModalConfirmarTerritorios();
            this.territoriosSelecionados = territoriosSelecionados;
            this.$emit(
                'atualizarTerritoriosSelecionados',
                this.territoriosSelecionados
            );
        },

        voltar() {
            this.changeShowModalConfirmarTerritorios();
            this.getLaudos();
        },
        handleModalLaudo(laudo) {
            this.showModalVisualizacao = !this.showModalVisualizacao;
            this.idLaudo = laudo;
        },
        handleSort(paramsProp) {
            this.pageParams = {
                page: this.pageParams.page,
                size: 20,
                sort: `${paramsProp.column},${paramsProp.order}`
            };
            this.getLaudos();
        },
        handleModalInsercaoResultados(rowInfo) {
            this.rowInfo = rowInfo;
            this.showModalInsercaoResultados =
                !this.showModalInsercaoResultados;
        },
        filtrar(filtros) {
            this.filtros = { ...filtros };
            this.getLaudos();
        },

        async requestLaudos() {
            try {
                this.loading = true;
                const { data } = await LaudosService.requestLaudos(
                    this.filtros,
                    this.pageParams
                );
                this.totalLaudos = data.totalItens;
                this.laudos = data.laudos;
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'laudos.erro.naoFoiPossivelCarregarOsDados'
                    )
                });
            } finally {
                this.loading = false;
            }
        },

        atualizaLaudoUnico(laudoUnico) {
            this.isLaudoUnico = laudoUnico === 'true';
        },

        changeShowModalSelecionarTerritorio() {
            this.tipoBusca = 'CAR';
            this.$emit('showModalSelecionarTerritorios');
        },

        desabilitarTerritorio(usuarioLogado) {
            if (usuarioLogado && usuarioLogado.authorities.length > 1) {
                return false;
            } else {
                if (
                    usuarioLogado.authorities[0].authority ===
                    'ROLE_FEATURE_LAUDO'
                ) {
                    return true;
                }
                return false;
            }
        }
    }
};
</script>

<style scoped lang="scss">
#laudos {
    .laudo-margin {
        margin-bottom: 20px;
    }

    header {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .radio-group-container {
        max-width: 250px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
    }

    .radio-button {
        margin-right: 20px !important;
    }

    .none {
        display: none !important;
    }
}
</style>
